<app-page-body>

  <!-- header -->
  <app-page-header [title]="title" [isForm]="true" [loading]="loading" (onBack)="onClose()" (onRefresh)="onReset()">
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form"  autocomplete="off">

      <section>
        <fieldset>
          <legend>
            {{pageVocabs+'legend'|translate}}
          </legend>

          <div class="row">
          </div>
          <div>
            <button class="mat-ripple btn tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] button-shadow btn-hover-rise btn-success"
              (click)="onAddClientRules()">+</button>

          </div>

          <div>

            <div *ngFor="let rule of newRulesModel; let i=index">

              <!--fields-->
              <app-create-rules-fields [isEdit]="isEdit" [rulesModel]="newRulesModel[i]"
                [index]="i" (limit)="newRulesModel[i].limit=$event" (period)="newRulesModel[i].period=$event"
                (endpoint)="newRulesModel[i].endpoint=$event" (periodType)="newRulesModel[i].periodType=$event"
                (removeIpRules)="onRemoveClientRules($event)" (form)="createRulesForms[i]=$event">
              </app-create-rules-fields>

            </div>

          </div>

        </fieldset>

      </section>

      <!-- form btns-->
      <app-form-btns [loading]="loading" [form]="form" [isEdit]="isEdit" (onClose)="onClose()"
        (onSubmit)="onSubmit()">
      </app-form-btns>

    </form>

  </div>

</app-page-body>
